/**
 * One-shot flag: full-card "+ Add Documentation Entry" can set this before
 * mounting `AssignmentCardResourceSectionEdit`, which consumes it on mount to
 * prepend a blank documentation row. Tip-path Box 5 starts a per-row edit
 * instead and does not use this flag.
 */
export const pendingDocumentationEntryRef = {
  current: false,
};

export const consumePendingDocumentationEntry = (): boolean => {
  if (!pendingDocumentationEntryRef.current) return false;
  pendingDocumentationEntryRef.current = false;
  return true;
};
